module.exports = __webpack_public_path__ + "img/12_67.4c37dc5c.png";